module.exports = __webpack_public_path__ + "static/media/plusIcon.457fd8af.svg";